<!-- Reschedule Confirmation Screen -->
<div *ngIf="showRescheduleConfirmation" @fadeAnimation class="d-flex w-100 rounded-4 overflow-hidden" style="height: 600px;">
  <!-- Left Panel -->
  <div class="d-flex justify-content-center align-items-center"
    style="width: 30%; background-color: #F6F8FF; position: relative;">
    <img src="assets/images/questions-not-css.svg" alt="Question Illustration" class="img-fluid" />
  </div>

  <!-- Right Panel -->
  <div style="width: 70%; background-color: #FFFFFF;">
    <div class="d-flex flex-column justify-content-between h-100 p-5">
      <!-- Top: Info + Image + Text -->
      <div class="text-center">
        <div class="mb-3">
          <img src="assets/images/calendar.png" alt="Calendar" class="img-fluid"
            style="max-height: 300px; width: auto;" />
        </div>

        <!-- Centered Text Box -->
        <div class="bg-white p-2">
          <h5 class="res-section-title-not m-0" style="color: #011044;">
            Looks like your visit is already set and approved for
            <span class="fw-bold" style="color:#D00162">
              {{ selectedDate | date: 'fullDate' }} at {{ selectedSlot }}
            </span>.
            <span>Still want to reschedule?</span>
          </h5>
        </div>
      </div>

      <!-- Buttons -->
      <div class="d-flex justify-content-center gap-3 mt-0">
        <button class="btn fw-semibold close-btn" (click)="close()">Close</button>
        <button class="btn fw-semibold cancel-btn" (click)="cancelScheduleVisit()">Cancel Visit</button>
        <button class="btn text-white fw-semibold book-slot-btn" (click)="proceedToReschedule()">
          <span>Yes, Reschedule</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Booking UI -->
<div *ngIf="!showRescheduleConfirmation" @fadeAnimation class="d-flex w-100 h-100 rounded-3">
  <!-- Left Panel -->
  <div class="d-flex justify-content-center align-items-center"
    style="width: 30%; background-color: #F6F8FF; position: relative;">
    <img src="assets/Real-Estate/Illustrations/book.png" alt="Book Visit" class="img-fluid"
      style="object-fit: contain; max-height: 90%; margin-top: 24%;" />
  </div>

  <!-- Right Panel -->
  <div style="width: 70%; background-color: #FFFFFF; height: 100%; overflow-y: auto;">
    <div class="p-4">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="re-section-title-not m-0" style="font-size: 22px; color: #011044;">Book A Free Visit</h4>
        <i class="bi bi-info-circle-fill fs-5" style="cursor: pointer; color: #011044;"
          data-bs-toggle="collapse" data-bs-target="#infoText"></i>
      </div>

      <!-- Hidden Info -->
      <div id="infoText" class="collapse text-muted small mb-3" style="margin-top: -10px;">
        Owner will be available on selected date and time.
      </div>

      <!-- Date Tabs -->
      <div class="d-flex flex-nowrap gap-4 overflow-auto mb-4">
        <button *ngFor="let date of dateTabs" class="date-tab text-center"
          [class.active]="selectedDate && selectedDate.toDateString() === date.date.toDateString()"
          (click)="selectDate(date.date)">
          <div class="small">{{ date.day }}</div>
          <div class="fw-semibold fs-4">{{ date.dateNum }}</div>
          <div class="small">{{ date.month }}</div>
        </button>

        <!-- Pick Date -->
        <div class="date-tab text-center d-flex flex-column justify-content-center position-relative"
          style="cursor: pointer; overflow-y: hidden;" (click)="openDatePicker()">
          <div class="fw-semibold">Pick</div>
          <i class="bi bi-calendar2-week-fill my-1" style="font-size: 16px;"></i>
          <div class="small">Date</div>
          <input type="date" #dateInput class="date-picker-input" [min]="minDate" [max]="maxDate"
            (change)="onDateChange($event)">
        </div>
      </div>

      <!-- Divider -->
      <div class="w-100" style="height: 2px; background: linear-gradient(to right, #ccc, #eee); margin-bottom: 1.5rem;"></div>

      <!-- Slot Booking -->
      <div class="bg-white rounded-3 shadow-sm p-4 mb-4 border" style="height: 470px;">
        <h5 class="re-section-title-not m-0 mb-3" style="color: #011044;">Book a Slot</h5>

        <!-- Morning -->
        <div class="d-flex justify-content-between align-items-start mb-4">
          <div class="d-flex align-items-center">
            <div class="fw-semibold fs-5 me-2 py-2" style="color: #011044;">Morning</div>
            <i class="bi bi-info-circle-fill" style="cursor: pointer; color: #011044;"></i>
          </div>
          <div class="d-flex flex-wrap gap-2 justify-content-end" style="max-width: 80%;">
            <div *ngFor="let slot of morningSlots" class="time-slot" [class.active]="selectedSlot === slot"
              (click)="selectSlot(slot)">
              {{ slot }}
            </div>
          </div>
        </div>

        <!-- Divider -->
        <div class="w-100" style="height: 2px; background: linear-gradient(to right, #ccc, #eee); margin-bottom: 1.5rem;"></div>

        <!-- Afternoon -->
        <div class="d-flex justify-content-between align-items-start mb-4">
          <div class="d-flex align-items-center" style="margin-top: 30px;">
            <div class="fw-semibold fs-5 me-2" style="color: #011044;">Afternoon</div>
            <i class="bi bi-info-circle-fill" style="cursor: pointer; color: #011044;"></i>
          </div>
          <div class="d-flex flex-wrap gap-2 justify-content-end" style="max-width: 80%;">
            <div *ngFor="let slot of afternoonSlots" class="time-slot" [class.active]="selectedSlot === slot"
              (click)="selectSlot(slot)">
              {{ slot }}
            </div>
          </div>
        </div>

        <!-- Divider -->
        <div class="w-100" style="height: 2px; background: linear-gradient(to right, #ccc, #eee); margin-bottom: 1.5rem;"></div>

        <!-- Evening -->
        <div class="d-flex justify-content-between align-items-start mb-4">
          <div class="d-flex align-items-center" style="margin-top: 30px;">
            <div class="fw-semibold fs-5 me-2" style="color: #011044;">Evening</div>
            <i class="bi bi-info-circle-fill" style="cursor: pointer; color: #011044;"></i>
          </div>
          <div class="d-flex flex-wrap gap-2 justify-content-end" style="max-width: 80%;">
            <div *ngFor="let slot of eveningSlots" class="time-slot" [class.active]="selectedSlot === slot"
              (click)="selectSlot(slot)">
              {{ slot }}
            </div>
          </div>
        </div>

        <!-- Info -->
        <div class="d-flex align-items-center px-3 py-2 rounded-2"
          style="background-color: #F6F8FF; color: #011044;">
          <i class="bi bi-info-circle-fill me-2" style="font-size: 18px;"></i>
          <div class="small fw-medium">Owner will be available at the above specified date and time</div>
        </div>
      </div>

      <!-- Footer Buttons -->
      <div class="d-flex justify-content-end mt-4 gap-4">
        <button class="btn fw-semibold cancel-btn" (click)="close()">Cancel</button>
        <button class="btn text-white fw-semibold book-slot-btn" (click)="submitForm()">
          <span>{{ scheduleVisitData ? 'Reschedule' : 'Book a Slot' }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
